import { Model } from "pinia-orm";
import Marker from "./Marker";

export default class Spreading extends Model {
  static entity = "spreadings";
  static primaryKey = "uuid";
  static aosType = "SPREADING";

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.attr(null),
      usage: this.attr([]),
      pictureUuid: this.attr(null),
      tagsType: this.attr([]),
      tracerCompound: this.attr([]),
      existenceOfAConstraint: this.boolean(false),
      constraintAccuracy: this.attr(null),
      analyticalStandard: this.attr(null),
      quantificationLimit: this.attr(null),
      isSourceTakenIntoAccount: this.boolean(true),
      justification: this.attr(null),
      typology: this.attr("SPREADING"),
      spreadingOrigin: this.string(""),
      description: this.attr(null),
      surface: this.attr(null),
      reference: this.attr(null),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),
    };
  }
}

export class SpreadingFusion extends Spreading {
  static entity = "spreadingFusions";
  static primaryKey = "uuid";
  static baseEntity = "spreadings";

  static fields() {
    return {
      ...super.fields(),
      spreadings: this.attr([]),
      spreadingType: this.attr("SPREADING_FUSION"),
    };
  }
}
